import {SxProps, Theme} from '@mui/material';
import theme from '../../../theme';

export const adornmentSx: SxProps<Theme> = {
    color: theme.palette.neutral[400],
};
